import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class SettingsNotificationPreferencesRoute extends Route {
  @service session;
  @service store;

  /** @inheritDoc */
  model() {
    return this.store.findRecord('user', this.session.currentUser.id, {
      include: 'devices.device-notification-preferences'
    });
  }

  /** @inheritDoc */
  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/settings/notification-preferences/');
  }
}

export default SettingsNotificationPreferencesRoute;
